cv.PostEditView = Marionette.LayoutView.extend({
  className: "view-post-edit",

  template: cv.Templates["post/edit"],

  regions: {
    region_body: "#region-body",
  },

  bindings: {
    ":el": {
      observe: ["stub", "draft_title", "status", "created_at"],
      update: function ($el, value, model, options) {
        // Set the text status
        if (model.isNew()) {
          this.$(".stub-preview-block").hide();
        } else {
          this.$(".stub-preview-block").show();
        }

        // Set the initial draft tile
        if (model.get("draft_title") != "") {
          this.$(".publish-post").removeClass("button-disabled");
          this.$("#title").val(model.get("draft_title"));
        } else {
          this.$(".publish-post").addClass("button-disabled");
        }

        // Set stub preview
        this.$(".stub-preview").text(model.get("stub"));
      },
    },
    ".post-meta": {
      observe: "published_at",
      update: function ($el, value, model, options) {
        if (moment(model.get("published_at")).isValid()) {
          $el.find(".edit-details").show();
        } else {
          $el.find(".edit-details").hide();
        }

        if (model.isNew()) {
          $el.find(".edit-share").hide();
          $el.find(".delete-post").hide();
        } else {
          $el.find(".edit-share").show();
          $el.find(".delete-post").show();
        }
      },
    },
    ".post-title": {
      observe: ["created_at"],
      update: function ($el, value, model, options) {
        if (model.isNew()) {
          $el.text("New Update");
        } else {
          $el.text("Edit Update");
        }
      },
    },
    ".unpublished-changes": {
      observe: ["status", "draft", "body"],
      update: function ($el, value, model, options) {
        if (!model.isNew() && model.get("status") == 1 && model.get("draft") != model.get("body")) {
          $el.show();
        } else {
          $el.hide();
        }
      },
    },
    ".last-modified": {
      observe: "updated_at",
      update: function ($el, value, model, options) {
        if (!model.isNew() && moment(this.model.get("updated_at")).isValid()) {
          $el.text(
            "Last saved at " +
              moment(this.model.get("updated_at") + "Z")
                .tz(cv.campaign.get("timezone"))
                .format("MMM D h:mm A"),
          );
        } else {
          $el.text("");
        }
      },
    },
  },

  events: {
    "click .back": "back",
    "keyup #title": "keyupTitle",
    "click .edit-details": "editDetails",
    "click .edit-share": "editShare",
    "click .delete-post": "deletePost",
    "click .publish-post": "publishPost",
  },

  validation: {},

  initialize: function (options) {
    this.options = _.extend(this.options, options);
    this.typingTimer;
    this.isTyping = false;
    if (!this.model.isNew()) {
      this.draft_url = this.model.url();
    } else {
      this.draft_url = "";
    }

    // Update the URL
    this.listenTo(
      this.model,
      "change:id",
      function (model) {
        cv.adminRouter.navigate("posts/edit/" + this.model.get("id"), { replace: true });
      },
      this,
    );

    // Redirect back to the listing if there's an error
    this.listenTo(
      this.model,
      "error",
      function () {
        cv.adminRouter.navigate("posts", { trigger: true });
      },
      this,
    );

    // Redirect back to listing when deleting
    this.listenTo(
      this.model,
      "destroy",
      function () {
        cv.adminRouter.navigate("posts", { trigger: true });
        vent.trigger("notif:success", "Post has been deleted.");
      },
      this,
    );

    console.log("PostEditView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  keyupTitle: function (e) {
    var $share_title = this.$("#title");

    if ($share_title.val() == "") {
      this.$(".publish-post").addClass("button-disabled");
    } else {
      this.$(".publish-post").removeClass("button-disabled");
    }

    // Save after finishing typing after 1 second
    if (this.isTyping == false) {
      this.isTyping = true;
    }
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(
      _.bind(function () {
        this.isTyping = false;

        if (this.model.isNew()) {
          if ($share_title.val() != "") {
            this.model.save(
              {
                draft_title: $share_title.val(),
              },
              {
                success: _.bind(function () {
                  // Update the draft URL
                  this.draft_url = this.model.url();
                }, this),
              },
            );
          }
        } else {
          if ($share_title.val() != "") {
            // Save the draft
            this.model.save(
              {
                draft_title: $share_title.val(),
              },
              {
                success: _.bind(function () {}, this),
              },
            );
          }
        }
      }, this),
      1000,
    );
  },

  editDetails: function (e) {
    e.preventDefault();

    // Trigger the URL
    cv.adminRouter.navigate("posts/edit/" + this.model.get("id") + "/details", { trigger: true });
  },

  editShare: function (e) {
    e.preventDefault();

    // Trigger the URL
    cv.adminRouter.navigate("posts/edit/" + this.model.get("id") + "/share", { trigger: true });
  },

  deletePost: function (e) {
    e.preventDefault();

    // Load the modal
    var view = new cv.ConfirmView({
      message: "Are you sure you want to delete this update?",
    });
    vent.trigger("modal:show", view);

    view.on(
      "confirm",
      function () {
        this.model.destroy();
      },
      this,
    );
  },

  publishPost: function (e) {
    e.preventDefault();

    var $share_title = this.$("#title");

    if ($share_title.val() == "") {
      var view = new cv.AlertView({
        message: "Please enter a valid title.",
      });
      vent.trigger("modal:show", view);
      return false;
    }

    var view = new cv.Views.Post.ConfirmPublishView({
      post_id: this.model.get("id"),
    });
    vent.trigger("modal:show", view);

    view.on(
      "confirm",
      function () {
        var should_share = view.model.get("share_post") == 1 ? 1 : 0;
        this.publish(should_share);
      },
      this,
    );
  },

  publish: function (should_share) {
    // If we are already published, then just save it
    if (moment(this.model.get("published_at")).isValid()) {
      var save_data = {
        draft_title: this.$("#title").val(),
        share_title: this.$("#title").val(),
        draft: this.model.get("draft"),
        body: this.model.get("draft"),
        share_post: should_share,
        status: 1,
      };
    } else {
      var save_data = {
        draft_title: this.$("#title").val(),
        share_title: this.$("#title").val(),
        draft: this.model.get("draft"),
        body: this.model.get("draft"),
        published_at: moment().utc().format("YYYY-MM-DD HH:00:00"),
        share_auto: this.model.get("share_auto"),
        share_description: this.model.get("share_description"),
        share_image: this.model.get("share_image"),
        share_post: should_share,
        status: 1,
      };
    }

    this.model.save(save_data, {
      success: _.bind(function () {
        // Set this back to 0
        this.model.set("share_post", 0);

        vent.trigger("post:updated", this.model.get("id"));
        vent.trigger("notif:success", "Your post has been published.");
      }, this),
    });
  },

  onShow: function () {
    // Bind the model
    this.stickit();

    var view = new cv.Views.VueComponentView({
      component: "BaseRichText",
      defaultArgs: {
        props: {
          name: "Enter content...",
          value: this.model.get("draft"),
        },
      },
    });
    view.on(
      "value_changed",
      function (val) {
        this.model.set("draft", val);

        if (this.draft_url != "") {
          // Save the draft
          $.ajax({
            url: this.draft_url,
            data: {
              draft: val,
            },
            dataType: "json",
            type: "PUT",
            success: _.bind(function (data) {
              this.model.set("updated_at", data.data.updated_at);
            }, this),
            error: _.bind(function (data) {}, this),
          });
        }
      },
      this,
    );
    this.showChildView("region_body", view);

    this.model.fetch({
      success: _.bind(function () {
        view.trigger("set_value", "value", this.model.get("draft"));
      }, this),
    });

    // If we are new post, create a new post ID and replace the URL
    /* if(!this.model.isNew()){
      this.model.fetch({
        success: _.bind(function(){
          this.editor = new cv.AppealEditorView({
            id : 'body',
            model : this.model,
            enable_draft : true,
            draft_url : this.model.url()
          });
          this.showChildView('region_body', this.editor);
        }, this)
      });
    }else{ */

    /*
      this.editor = new cv.AppealEditorView({
        id : 'body',
        model : this.model,
        enable_draft : true,
        draft_url : ''
      });
      this.showChildView('region_body', this.editor);

    }*/
  },
});
